import React from 'react';
import { connect } from 'react-redux';
import { FEED_PUSHER_SETTING } from '../../../constants';
import { checkPermisson } from '../../../selectors/common';
import ApproveAndCancelIcons from './ApproveAndCancelIcons';
import DropdownListFeedStatus from './DropdownListFeedStatus';
import DropdownListInvalidateOdds from './DropDownListInvalidateOdds';
import SettingsButton from './SettingsButton';

const mapToProps = (state) => ({
  checkPermisson: (payload) => checkPermisson(state, payload),
});
const FeedSettingsRows = (props) => (
  props.feedPusherSettings.map((leagueItem) => {
    const individualLeagueData = props.leagues.find((league) => leagueItem.leagueId === league.id);
    if (!individualLeagueData) return null;
    return (
      <tr
        key={leagueItem.leagueId}
        className={`table-style__row  
          ${props.feedStatusState === leagueItem.leagueId && 'edit-feed'} 
          ${props.invalidateOddsStatusState === leagueItem.leagueId && 'edit-odds'}`}
      >
        <td>{individualLeagueData.name}</td>

        <td>
          <span className="feed-status">{FEED_PUSHER_SETTING.FEED_STATUS[leagueItem.feedStatus]}</span>
          <div
            className={`dropdown dropdown--feed ${props.feedStatusDropdownState === leagueItem.leagueId && 'is-open'}`}
            onClick={props.togglefeedStatusDropdownState.bind(this, leagueItem.leagueId)}
          >
            <span>{FEED_PUSHER_SETTING.FEED_STATUS[leagueItem.feedStatus]}</span>
            <DropdownListFeedStatus
              league={leagueItem}
              handleFeedStatusChange={props.handleFeedStatusChange}
            />
          </div>
        </td>

        <td>
          <span className="invalidate-odds">{FEED_PUSHER_SETTING.INVALIDATE_ODDS[leagueItem.invalidateOdds]}</span>
          <div
            className={`dropdown dropdown--odds ${props.invalidateOddsDropdown === leagueItem.leagueId && 'is-open'}`}
            onClick={props.toggleInvalidateOddsDropdown.bind(this, leagueItem.leagueId)}
          >
            <span>{FEED_PUSHER_SETTING.INVALIDATE_ODDS[leagueItem.invalidateOdds]}</span>
            <DropdownListInvalidateOdds
              league={leagueItem}
              handleInvalidateOddsChange={props.handleInvalidateOddsChange}
            />
          </div>
        </td>
        <td>
          <div className="d-flex justify-content-center">
            {props.checkPermisson(props.permissionToUpdate)
              && (
                <SettingsButton
                  className="option-btn option-btn--feed"
                  onClick={props.toggleFeedStatusState.bind(this, leagueItem.leagueId)}
                  disabled={(props.feedStatusState !== null
                    && props.feedStatusState !== leagueItem.leagueId)
                    || (props.invalidateOddsStatusState)}
                  btnName="Feed Status"
                />
              )}
            <div className="action">
              <ApproveAndCancelIcons
                requestForUpdate={props.requestForUpdate}
                closeConfirmationBtns={props.closeConfirmationBtns}
              />
            </div>
            {props.checkPermisson(props.permissionToInvalidateOdds)
              && (
                <SettingsButton
                  className="option-btn option-btn--odds"
                  onClick={props.toggleInvalidateOddsStatusState.bind(this, leagueItem.leagueId)}
                  disabled={(props.invalidateOddsStatusState !== null
                    && props.invalidateOddsStatusState !== leagueItem.leagueId)
                    || props.feedStatusState}
                  btnName="Invalidate Odds"
                />
              )}
          </div>
        </td>
      </tr>
    );
  })
);
export default connect(mapToProps)(FeedSettingsRows);
